import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Heading from '../../../../components/Typography/Heading/Heading';
import styles from './HorseBox.module.scss';
import cn from 'classnames';
const HorseBox = ({ children, text, className }) => {
    return (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [text && _jsx(Heading, { title: text, size: 1 }), _jsx("div", Object.assign({ className: styles.wrapper }, { children: children }))] })));
};
export default HorseBox;
